import { Message } from '@oneflowab/pomes';

import { MenuItem } from 'components/menu-item';
import Copy from 'components/icons/copy';

export type Props = {
  disabled?: boolean;
  onClick: Function;
};

export const CopyMenuItem = ({ disabled, onClick }: Props) => (
  <MenuItem
    buttonId="copy-contract-menu-item"
    icon={Copy}
    label={<Message id="Duplicate" comment="Label for duplicate action in menu." />}
    disabled={disabled}
    onClick={onClick}
  />
);
